// Side-effect import: registers the [data-plg-modal-label] click
// handler inside the donate widget iframe. widget.js#init registers
// the same handler on the host page side; both pick up clicks in
// their respective documents and route through openModal.
//
// Also primes the dialog-polyfill — openModal's path-3 (in-iframe
// fallback when the channel handshake fails) renders a <dialog>
// inside this iframe, so Safari <15.4 donors need the polyfill
// loaded here the same way Widgets.js#init loads it on the host page.
// The polyfill ships from the same origin this iframe is served from.
import { registerOpenModalTriggers } from 'src/widgets/embed/openModalTriggers'
import { polyfillDialog } from 'src/widgets/embed/dialog'

polyfillDialog(location.origin)
registerOpenModalTriggers()
